export const BreadcrumbMapper = {
  poam: "POA&M",
  verify: "Verify",
  "Integrated-Platforms": "Integrated Platforms",
  profile: "Setting",
  "vendor-management": "Vendor management",
  "requirement-analysis": "Requirement Analysis",
  "risk-dashboard": "Risk Dashboard",
  assessment: "Vendor Assessment",
  procurement: "Vendor Procurement",
  onboard: "Onboard Vendor",
  "security-review": "Security Review",
  "compliance-reports": "Compliance Reports",
  // settings: "Settings",
  "risk-management": "Risk Management",
  "risk-library": "Risk Library",
  "risk-register": "Risk Register",
  "action-tracker": "Action Tracker",
  "access-management": "Acess Management",
  accounts: "Accounts",
  reviews: "Reviews",
  rbac: "Role Based Access Control",
  users: "Users",
  roles: "Roles",
  organization: "Organization",
  "doc-compliance": "Document Compliance",
  policies: "Policies",
  editor: "Editor",
  agent: "AI Agent",
};
